import { makeAutoObservable } from "mobx";

export class DeleteStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  rowDelete = undefined;
  setRowDelete = (values) => {
    this.rowDelete = values;
  };
}
